import { analyticsDestinationPermissions, analyticsDestinationSection } from "./analytics-destinations";

export const ANALYTICS_REPORT_PAGES = [
  "/admin/analytics", "/admin/analytics/customers", "/admin/analytics/demand",
  "/admin/analytics/sales", "/admin/analytics/operations", "/admin/ads",
] as const;

export function analyticsReportPermissions(href: string): ReadonlyArray<string> {
  if (href.split(/[?#]/)[0] !== "/admin/analytics") return [];
  const view = analyticsReportView(href);
  if (!view) return [];
  const permissions = analyticsDestinationPermissions(analyticsDestinationSection(view));
  return view === "acquisition" ? [...permissions, ...analyticsDestinationPermissions("ads")] : permissions;
}

export function analyticsReportView(href: string) {
  const query = new URLSearchParams(href.split("?")[1]?.split("#")[0]);
  return query.get("view") ?? query.get("section") ?? query.get("tab");
}
